export const spacing = [4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 96]
